var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-scheduler",
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("automation.configSchedulerAuto"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "", disabled: !_vm.isChanged() },
                on: { click: _vm.save },
              },
              [_vm._v(" " + _vm._s(_vm.$t("automation.saveChanges")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close", 0)
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.close")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("RRuleGenerator", {
        attrs: { "max-count": 365 },
        model: {
          value: _vm.rrule,
          callback: function ($$v) {
            _vm.rrule = $$v
          },
          expression: "rrule",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }